import React, {useEffect, useState} from 'react';
import styles from './AttachmentsModal.module.css';
import {usePalette} from './Customizables';
import useAttachments from '../hooks/useAttachments';
import {Button, Modal, ModalBody} from "reactstrap";
import HttpRequest from "./HttpRequest";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import CustomModalHeader from "./CustomModalHeader";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFolderOpen} from "@fortawesome/free-solid-svg-icons";
import SolidButton from "./SolidButton";
import PulseButton from "./PulseButton";

export default function AttachmentsModal({children}) {
    const { t } = useTranslation()
    const [open, setOpen] = useState(false);
    const [hasAttachments, ,attachments, downloadAttachments] = useAttachments();
    const palette = usePalette();
    const document = useSelector(state => state.document);

    useEffect(async () => {
        if(open && hasAttachments) {
            await downloadAttachments(true)
        }
    }, [open, hasAttachments]);

    function toggle() {
        setOpen(prev => !prev);
    }

    function handleClose() {
        setOpen(false);
    }

    return (
        <React.Fragment>
            {hasAttachments &&
                <PulseButton color='primary' onClick={toggle}  style={{
                    borderRadius: '50px 0 0 50px',
                }} className={styles.fabButton} repeatInfinite={false}>
                    <FontAwesomeIcon icon={faFolderOpen}></FontAwesomeIcon>
                </PulseButton>
            }
            <Modal isOpen={open} toggle={handleClose}>
                <CustomModalHeader toggle={toggle}>
                    <div>{t('attachments modal title')}</div>
                </CustomModalHeader>
                <ModalBody>
                    <div>
                        {
                            attachments && attachments.length > 0 ?
                                <div>
                                    <div>
                                        <p>
                                            {t('attachments modal description')}
                                        </p>
                                        <p>
                                            {t('attachments modal description 2')}
                                        </p>
                                    </div>
                                    {
                                        attachments.map(f => (
                                            <div key={f}>
                                                <a href={`${HttpRequest.backend}/pdf/attachments/${document.report.ticket}/${f}`}
                                                    target={'_blank'}
                                                >{f}</a>
                                            </div>
                                        ))
                                    }
                                </div> : null
                        }
                    </div>
                </ModalBody>
            </Modal>
        </React.Fragment>
    );
}
